"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = update;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _ = require(".");

var _utils = require("./utils");

function update(_x, _x2) {
  return _update.apply(this, arguments);
}

function _update() {
  _update = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref, item) {
    var client, path, id, response, _ref2, _ref2$response;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            client = _ref.client, path = _ref.path, id = _ref.id;
            (0, _utils.checkValidId)(id);
            _context.prev = 2;
            _context.next = 5;
            return client.put(path + ("/" + id), (0, _extends2.default)({}, item), {
              headers: {
                Accept: _.APPLICATION_JSON,
                'Content-Type': _.APPLICATION_JSON
              }
            });

          case 5:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);

            if (!(((_ref2 = _context.t0) == null ? void 0 : (_ref2$response = _ref2.response) == null ? void 0 : _ref2$response.status) === 404)) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("return", null);

          case 13:
            throw new Error("Failed to update item with id: " + id + " and path: " + path);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _update.apply(this, arguments);
}